import { AppLayout } from '@fsd/app/layout';
import { gatesRoutes } from '@fsd/app/routes';
import { Navigate, type RouteObject } from 'react-router-dom';
import AmaruGuard from './components/guards/AmaruGuard';
import AuthGuard from './components/guards/AuthGuard';
import CaptaGuard from './components/guards/CaptaGuard';
import { FsdContext } from './FsdContext';
import routes from './routes';

// La rama MUI entra con `lazy`: un import estático de AppContexts.tsx la descargaría también al
// abrir una ruta de src/fsd/. Lo verifica `yarn check:fsd-boundary`.
export const appRoutes: RouteObject[] = [
  {
    lazy: () => import('./AppContexts').then((m) => ({ Component: m.ApiContext })),
    children: routes,
  },
  {
    element: <FsdContext />,
    children: [
      {
        // Un solo AppLayout para todos los grupos: el marco no se vuelve a montar entre secciones.
        element: (
          <AuthGuard loadingFallback={null}>
            <AppLayout />
          </AuthGuard>
        ),
        children: [
          {
            path: 'gates',
            element: (
              <AmaruGuard section="Sec:Compuertas" deniedFallback={<Navigate to="/" replace />} />
            ),
            children: [
              {
                // Movimientos de compuerta en src/fsd: solo Capta mientras la página se itera.
                element: <CaptaGuard redirectTo="/" />,
                children: gatesRoutes,
              },
            ],
          },
        ],
      },
    ],
  },
];
